import { useState } from "react";

import { t } from "@impero-com/common/utils/i18n";
import { Modal } from "@impero-com/ui";
import { Checkbox } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";

import { Content } from "components/modals/Content";
import { Footer } from "components/modals/Footer";

import { useFeatureFlag } from "../../../../utils/hooks/useFeatureFlag";

import { RiskMatrixExportOptions } from "./export";
import * as theme from "./theme.css";

interface ExportRiskMatrixPopupProps {
    onExportMatrix: (options: RiskMatrixExportOptions) => void;
    onCancel: () => void;
}

const ExportRiskMatrixPopup = (props: ExportRiskMatrixPopupProps) => {
    const [exportUnassignedControls, setExportUnassignedControls] =
        useState(false);
    const [exportAsCSV, setExportAsCSV] = useState(false);

    const exportAsCSVFlagEnabled = useFeatureFlag("exportAsCSV");

    const doExportMatrix = () => {
        const options: RiskMatrixExportOptions = {
            withAllUnassignedControls: exportUnassignedControls,
            asCSV: exportAsCSV,
        };
        props.onExportMatrix(options);
        props.onCancel();
    };

    const onChangeExportUnassignedControlsCheckbox = (
        event: CheckboxChangeEvent
    ) => {
        setExportUnassignedControls(event.target.checked);
    };

    const onChangeExportAsCSVCheckbox = (event: CheckboxChangeEvent) => {
        setExportAsCSV(event.target.checked);
    };

    return (
        <Modal
            variant="content"
            open
            onClose={props.onCancel}
            title={t("RiskDirectory_Export")}
            footer={
                <Footer
                    onClose={props.onCancel}
                    onConfirm={doExportMatrix}
                    confirmLabel={t("Export")}
                />
            }
        >
            <Content body={t("RiskDirectory_Export_Description")}>
                <div className={theme.dialogCheckboxesColumn}>
                    <Checkbox
                        checked={exportUnassignedControls}
                        onChange={onChangeExportUnassignedControlsCheckbox}
                    >
                        {t("RiskDirectory_Export_IncludeUnassignedControls")}
                    </Checkbox>
                    {exportAsCSVFlagEnabled && (
                        <Checkbox
                            checked={exportAsCSV}
                            onChange={onChangeExportAsCSVCheckbox}
                        >
                            {t("RiskDirectory_Export_AsCSV")}
                        </Checkbox>
                    )}
                </div>
            </Content>
        </Modal>
    );
};

export { ExportRiskMatrixPopup };
